import { Component, Emit, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import { COUNTRIES } from '@/constants';
import RegisterService from '@/account/register/register.service';
import { Authority } from '@/shared/security/authority';
import { getCurrentTimeZoneOffset, LOCAL_STORAGE_CONSTANTS } from '@/shared/constants/ds-constants';
import PhoneService from '@/account/phone.service';

@Component({
  computed: {},
  methods: {},
  components: {},
})
export default class PhoneValid extends Vue {
  @Prop(Boolean) readonly openModal;
  @Prop(Boolean) readonly isEmail;

  @Inject('registerService') private registerService: () => RegisterService;

  countries = COUNTRIES;
  countrySelect = null;
  minLeft = '3';
  secLeft = '00';
  existedMailOrPhone = false;
  timeDown;
  isSendingCode = false;
  sendedVerificationCode = false;
  isVerificationCodeSuccess = false;
  public verifyFormModel = {
    countryCode: '',
    phoneNumber: '',
    type: 1,
    code: '',
    email: '',
    emailCode: '',
    login: '',
    timeZone: '',
  };
  isReConFirmCode = false;
  registerFormModel = {
    countryCode: '',
    phoneNumber: '',
    email: '',
    code: '',
    termOfService: 1,
    receiveNews: 0,
    emailCode: '',
    purposeSet: [],
    nameConnectome: 'Warren',
    login: '',
    lastName: '',
    deleted: 0,
    langKey: 'en',
    authorities: [Authority.USER],
    invitationCode: '',
    isRegister: true,
    showOnboardDialog: 1,
    timeZone: '',
    isGuest: false,
    guestLogin: '',
    isEmailLogin: false,
    isUpdateGuestToUser: false,
    id: '',
  };
  countDown;
  SEND_CODE_TIMEOUT = 180;
  isInvalidMailOrPhone = false;
  confirmCode = '';
  isExpiredCode = false;
  isInCorrectPhone = false;
  changedInput = false;
  localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
  isShowResendCode = false;

  @Emit('close') close() {}

  @Watch('confirmCode')
  onConfirmCodeChange() {
    this.isReConFirmCode = true;
  }

  mounted() {
    this.countrySelect = localStorage.getItem(LOCAL_STORAGE_CONSTANTS.LOCALE);
  }

  checkRegexPhone() {
    this.registerFormModel.phoneNumber = this.registerFormModel.phoneNumber.trim().replace(' ', '');
    const pattern = new RegExp('\\b\\d{6,15}\\b');
    this.isInvalidMailOrPhone = !pattern.test(this.registerFormModel.phoneNumber);
    return !this.isInvalidMailOrPhone;
  }

  @Watch('registerFormModel.phoneNumber', { deep: true })
  onPhoneTxtChange() {
    this.changedInput = true;
  }

  save() {
    this.$emit('save', this.registerFormModel);
    this.close();
  }

  checkRegexEmail() {
    this.existedMailOrPhone = false;
    this.registerFormModel.email = this.registerFormModel.email.trim().replace(' ', '').replace(/\s+/g, '');
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.isInvalidMailOrPhone = !pattern.test(this.registerFormModel.email.replace(/\.+(?=@)/g, ''));
  }

  getVerificationCode() {
    this.confirmCode = '';
    this.isExpiredCode = false;
    this.existedMailOrPhone = false;

    if (this.isEmail) {
      this.registerFormModel.email = this.registerFormModel.email.trim().replace(' ', '').replace(/\s+/g, '');

      if (!this.registerFormModel.email) {
        return;
      }

      if (this.isSendingCode || this.isInvalidMailOrPhone) {
        return;
      }
    } else {
      this.registerFormModel.phoneNumber = this.registerFormModel.phoneNumber.trim().replace(' ', '').replace(/\s+/g, '');

      if (
        !this.registerFormModel.phoneNumber ||
        (this.registerFormModel.phoneNumber && this.registerFormModel.phoneNumber.length < 6) ||
        !this.checkRegexPhone() ||
        !this.countrySelect
      ) {
        return;
      }

      this.registerFormModel.countryCode = this.countrySelect;
    }
    this.registerFormModel.id = this.localStorageUser.id;
    this.sendOTP();
  }

  // callApiSendCodeToPhone() {
  //   this.registerFormModel.login = this.registerFormModel.phoneNumber;
  //   this.phoneService()
  //     .send(this.registerFormModel)
  //     .then(res => {
  //       this.existedMailOrPhone = false;
  //       this.registerFormModel.countryCode = this.countrySelect;
  //
  //       clearTimeout(this.countDown);
  //       this.countDownTimer(this.SEND_CODE_TIMEOUT);
  //       this.isSendingCode = true;
  //       this.isShowResentCodeForPhone = true;
  //       this.isInCorrectPhone = false;
  //     })
  //     .catch(error => {
  //       this.isShowResentCodeForPhone = false;
  //       const err = error.response.data;
  //       switch (err.code) {
  //         case '010': {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //         case '011': {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //         case '003': {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //         // case '004': {
  //         //   this.existedMailOrPhone = true;
  //         //   break;
  //         // }
  //         case '004': {
  //           this.existedMailOrPhone = true;
  //           this.isInCorrectPhone = true;
  //           break;
  //         }
  //         default: {
  //           this.existedMailOrPhone = true;
  //           break;
  //         }
  //       }
  //     });
  // }

  sendOTP() {
    if (this.minLeft === '0' && this.secLeft === '00') {
      // this.isSendingCode = false;
    } else {
      this.resetTime();
      clearInterval(this.timeDown);
    }

    // this.registerFormModel.email = this.mailTxt;
    this.registerService()
      .sendOTP(this.registerFormModel)
      .then(res => {
        this.isSendingCode = true;
        this.isShowResendCode = true;
        clearTimeout(this.countDown);
        this.countDownTimer(this.SEND_CODE_TIMEOUT);
        this.existedMailOrPhone = false;
        this.isInCorrectPhone = false;
      })
      .catch(error => {
        this.isShowResendCode = false;
        const err = error.response.data;
        switch (err.code) {
          case '010': {
            this.existedMailOrPhone = true;
            break;
          }
          case '011': {
            this.existedMailOrPhone = true;
            break;
          }
          case '003': {
            this.existedMailOrPhone = true;
            break;
          }
          case '004': {
            this.isInCorrectPhone = true;
            this.existedMailOrPhone = true;
            break;
          }
          case '008': {
            this.isInCorrectPhone = true;
            break;
          }
          default: {
            this.$bvToast.toast(`${this.$t('newLearningCenter.unknownError')}`, {
              toaster: 'b-toaster-bottom-right',
              title: `${this.$t('newLearningCenter.error')}`,
              variant: 'danger',
              solid: true,
              autoHideDelay: 4000,
            });
            break;
          }
        }
      });
  }

  public countDownTimer(countDownTime: number) {
    if (countDownTime >= 0) {
      this.minLeft = '' + Math.floor(countDownTime / 60);
      // @ts-ignore
      this.secLeft = Math.floor(countDownTime % 60);
      // @ts-ignore
      this.secLeft = this.secLeft < 10 ? '0' + this.secLeft : this.secLeft;

      if (countDownTime > 0) {
        this.timeDown = this.countDown = setTimeout(() => {
          this.countDownTimer(countDownTime - 1);
        }, 1000);
      } else {
        this.isSendingCode = false;
        this.isExpiredCode = true;
      }
    }
  }

  resetTime() {
    this.minLeft = '3';
    this.secLeft = '00';
  }

  checkRegexCode() {
    // this.isShowRequiredOptWarning = true;
    const numberRegex = /^\d+$/;
    return numberRegex.test(this.confirmCode);
  }

  verifyCode() {
    this.registerFormModel.isEmailLogin = false;
    this.registerFormModel.code = this.confirmCode;
    this.registerService()
      .verifyCodeUserExist(this.registerFormModel)
      .then(res => {
        this.sendedVerificationCode = true;
        if (res?.data?.code == '000') {
          this.isVerificationCodeSuccess = true;
        }
        clearTimeout(this.countDown);
        this.$emit('update:loginFailedAttempt', 0);
      })
      .catch(error => {
        this.sendedVerificationCode = true;
        const err = error.response.data;
        this.isVerificationCodeSuccess = false;
        this.$emit('update:loginFailedAttempt', err.loginFailedCount);
      })
      .finally(() => {
        this.isReConFirmCode = false;
      });
  }

  confirm() {
    if (!this.checkRegexCode() || !this.confirmCode || (this.confirmCode && this.confirmCode.length < 6)) {
      return;
    }

    if (!this.isVerificationCodeSuccess && this.sendedVerificationCode && this.isSendingCode && !this.isReConFirmCode) {
      return;
    }

    if (this.minLeft === '0' && this.secLeft === '00') {
      return;
    }

    // @ts-ignore
    if (this.minLeft == 0 && this.secLeft == 0 && this.sendedVerificationCode) {
      this.isExpiredCode = true;
      this.sendedVerificationCode = false;
      return;
    }
    // this.checkEmailCorrect = false;
    if (
      this.registerFormModel.email !== this.verifyFormModel.email &&
      this.registerFormModel.phoneNumber !== this.verifyFormModel.phoneNumber
    ) {
      this.resetTime();
      clearInterval(this.timeDown);
      return;
    }

    this.registerFormModel.timeZone = getCurrentTimeZoneOffset();

    if (!this.isEmail) {
      this.registerFormModel.isEmailLogin = false;
    } else {
      this.registerFormModel.emailCode = this.confirmCode;
      this.registerFormModel.isEmailLogin = true;
    }
    this.verifyCode();
  }
}
